// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dep-level-row{display:flex;align-items:center;gap:8px;margin:4px 0}.dep-level-row span{flex:1}.dep-level-row input[type=color]{width:28px;height:20px;border:0;padding:0}", ""]);
// Exports
module.exports = exports;
